import { useTranslation } from 'react-i18next';
import RegistrationForm from '../RegistrationForm/RegistrationForm';
import type { BannerContentProps } from './bannerContentRegistry';
import { useWindowSize } from '../../hooks/useWindowSize';
import HBText from '../honeybook-ui/HBText/HBText';

const JanuaryPromoBannerContent = ({ buttonText }: BannerContentProps) => {
    const { t } = useTranslation();
    const { isLargeUp } = useWindowSize();

    return (
        <div className="promo-banner__january-container">
            <div className="promo-banner__january-content">
                <HBText
                    tag="h3"
                    type="body-l"
                    customClass="promo-banner__january-title"
                >
                    {isLargeUp
                        ? (t('jan26.banner.titleDesktop') as string)
                        : (t('jan26.banner.titleMobile') as string)}
                </HBText>

                <RegistrationForm
                    customClass="promo-banner__january-cta"
                    buttonStyle="secondary-alt"
                    source="promo banner"
                    buttonText={buttonText}
                    size="x-small"
                />
                <span className="promo-banner__january-terms">
                    {t('jan26.banner.terms') as string}
                </span>
            </div>
        </div>
    );
};

export default JanuaryPromoBannerContent;
